/**
 * Screen-reader announcement for a terms-consent step that appears asynchronously — after the
 * login form's partial response (Landing) or the consent probe (MSTeamsLanding). Neither flow
 * moves focus, so a persistent live region is the only thing that tells a screen-reader user
 * that a required step, and the reason for it, just appeared.
 *
 * Shared by both pages so they announce the same framing their visible copy uses. The
 * full-page interstitials (TermsConsentPage, MSTeamsOAuthTocConsent) need no announcement:
 * they are fresh page loads, announced normally.
 */

const REQUIREMENT = "Terms of consent required.";

const REASON_DETAIL: Record<string, string> = {
    first_time: "Please review and accept the terms to continue.",
    updated: "The terms have been updated since you last accepted them.",
    grandfathered: "We've improved our records around terms acceptance — please re-accept.",
};

/** An unknown or missing reason falls back to first-time framing, as the consent components do. */
export function termsConsentAnnouncement(reason?: string): string {
    return `${REQUIREMENT} ${(reason && REASON_DETAIL[reason]) || REASON_DETAIL.first_time}`;
}
